// extracted by mini-css-extract-plugin
module.exports = {"chart":"SectionChart_chart__uKPY9","container":"SectionChart_container__5Y8az","chart__container":"SectionChart_chart__container__lmcTR"};